import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import { of } from 'rxjs';
import { ClientService } from '../../@core/data/clients/client.service';

import { NbToastrService } from '@nebular/theme';
import { LoggedUserPermissionsLoaded, LoggedUserPermissionsRequested, PermissionsError, PermissionsLoaded, PermissionsRequested, UserPermissionsError, UserPermissionsLoaded } from './permissions.action';
import { UserPermissionsRequested } from './permissions.action';
import { IPermissionsState } from './permissions.state';
import { LoggedUserLoaded } from '../users/users.actions';


@Injectable()
export class PermissionsEffects {
  constructor(
    private actions$: Actions,
    private clientService: ClientService
  ) {}

  requestUserPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPermissionsRequested),
      mergeMap(() =>
        this.clientService.getUserPermissions().pipe( //gets permissions of all users of the company
          map((response: {status:boolean, data:IPermissionsState['userPermissions']}) => {
            if (response?.data){
              return UserPermissionsLoaded({ userPermissions: response.data });
            }
            return UserPermissionsLoaded({ userPermissions: [] });
          }),
          catchError((error: any) => of(UserPermissionsError()))
        )
      )
    )
  );

  requestLoggedUserPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoggedUserPermissionsRequested),
      mergeMap(() =>
        this.clientService.getLoggedUserToCompanyPermissions().pipe( //gets permissions of the logged user for the company he logged in for
          map((response: {status:boolean, data:IPermissionsState['loggedUserPermissions']}) => {
            if (response?.data){
              return LoggedUserPermissionsLoaded({ loggedUserPermissions: response.data });
            }
            return LoggedUserPermissionsLoaded({ loggedUserPermissions: [{ id: 0, companyProfileUuid: '', uuid: '', permissionId: 0, gestiuneId: 0, code: '', name: '', orderIndex: 0 }] });
          }),
          catchError((error: any) => of(UserPermissionsError()))
        )
      )
    )
  );

  requestAvailablePermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionsRequested),
      mergeMap(() =>
        this.clientService.getAvailableClientPermissions().pipe(  //gets all available permission options
          map((response: {status:boolean, data:IPermissionsState['permissions']}) => {
            if (response?.data){
              return PermissionsLoaded({ permissions: response.data });
            }
            return PermissionsLoaded({ permissions: [] });
          }),
          catchError((error: any) => of(PermissionsError()))
        )
      )
    )
  );

}
